<template>
  <div>
    <div v-if="this.endTour" class="text-center">
      <v-btn
        variant="text"
        icon
        class="tour-button"
        color="#a5d867"
        @click="startTour"
        ><v-icon @click="startTour" :icon="'guide'"
      /></v-btn>
    </div>
    <v-tour
      name="myTour"
      class="app-tour"
      :steps="steps"
      :callbacks="myCallbacks"
      :options="{
        labels: {
          buttonSkip: $t('common.tourSkip'),
          buttonPrevious: $t('common.tourPrevious'),
          buttonNext: $t('common.tourNext'),
          buttonStop: $t('common.tourFinish'),
        },
      }"
    ></v-tour>
  </div>
</template>

<script>
export default {
  name: "my-tour",
  data() {
    return {
      endTour: null,
      myCallbacks: {
        onSkip: this.customSkipCallback,
        onFinish: this.customFinishCallback,
      },
    };
  },
  computed: {
    steps() {
      const t = (key) => this.$t("loginScreen." + key);
      return [
        {
          target: ".the-journey-logo",
          header: { title: t("tourStep1Title") },
          content: t("tourStep1Content"),
          params: {
            placement: "top",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
        {
          target: ".login-options-container",
          header: { title: t("tourStep2Title") },
          content: t("tourStep2Content"),
          params: {
            placement: "top",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
        {
          target: ".firebaseui-idp-google",
          header: { title: t("tourStep3Title") },
          content: t("tourStep3Content"),
          params: {
            placement: "top",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
        {
          target: ".firebaseui-idp-password",
          header: { title: t("tourStep4Title") },
          content: t("tourStep4Content"),
          params: {
            placement: "top",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
        {
          target: ".send-link-email-button",
          header: { title: t("tourStep5Title") },
          content: t("tourStep5Content"),
          params: {
            placement: "top",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
        {
          target: ".send-code-phone-button",
          header: { title: t("tourStep6Title") },
          content: t("tourStep6Content"),
          params: {
            placement: "top",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
        {
          target: ".user-menu-container",
          header: { title: t("tourStep7Title") },
          content: t("tourStep7Content"),
          params: {
            placement: "bottom",
            enableScrolling: false,
            offset: [0, 20],
            highlight: true,
          },
        },
      ];
    },
  },
  methods: {
    // customPreviousStepCallback (currentStep) {
    //     // console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep + 1))
    // },
    // customNextStepCallback (currentStep) {
    //     // console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep + 1))

    //     // if (currentStep === 1) {
    //     //     console.log('[Vue Tour] A custom nextStep callback has been called from step 2 to step 3')
    //     // }
    // },
    customSkipCallback() {
      // console.log('[Vue Tour] A custom skip callback has been called on step ')
      this.endTour = true;
      localStorage.endTour = true;
    },
    customFinishCallback() {
      // console.log('[Vue Tour] A custom finish callback has been called on step ')
      this.endTour = true;
      localStorage.endTour = true;
    },
    startTour() {
      localStorage.removeItem("endTour");
      this.endTour = null;
      this.$tours["myTour"].start();
    },
  },
  mounted: function () {
    this.endTour = localStorage.endTour;
    if (!localStorage.endTour) {
      setTimeout(() => {
        this.$tours["myTour"].start();
      }, 500);
    }
  },
};
</script>
<style></style>
